import { gql } from 'apollo-angular'

import { SUBSCRIPTION_WITH_PRICING_FIELDS } from '../../fragments/subscription-with-pricing.fragment'

export const GET_SUBSCRIPTIONS_AND_PRICING = gql`
  query Subscriptions(
    $currentDate: DateTime!
    $page: Int
    $limit: Int
    $where: Subscription_where_and
  ) {
    Subscriptions(
      select: true
      where: {
        AND: [
          {
            OR: [
              { endDate: { equals: null } }
              { endDate: { greater_than_equal: $currentDate } }
            ]
          }
          $where
        ]
      }
      page: $page
      limit: $limit
      sort: "organization.name,product.id"
    ) {
      totalDocs
      totalPages
      page
      docs {
        ...SubscriptionWithPricingFields
      }
    }
  }
  ${SUBSCRIPTION_WITH_PRICING_FIELDS}
`
